<header class=" w-100">
  <div class="shadow">
    <nav class="container">
      <div class="menu d-flex align-items-center justify-content-between">
        <div class="logo d-flex">
          <div class="icon-menu d-lg-none me-2" (click)="open = !open">
            <img *ngIf="!open" class="open" src="./assets/images/svg/open-menu.svg" alt="">
          </div>
          <a [href]="environment.redirectHome">
            <img class="img-fluid" src="./assets/images/svg/logo.svg" alt="logo">
          </a>
        </div>

        <div class="links d-none d-lg-block">
          <a class="cursor-pointer" [href]="environment.redirectHome">Inicio</a>

          <a class="cursor-pointer" [href]="environment.redirectHome">Nosotros</a>

          <a class="cursor-pointer" [href]="environment.redirectHome">Requisitos</a>

          <a class="cursor-pointer" [href]="environment.redirectHome">Beneficios</a>

          <a class="cursor-pointer" [href]="environment.redirectHome">Preguntas frecuentes</a>

          <a class="cursor-pointer" [href]="environment.redirectHome">Blog</a>

        </div>

        <div class="contact d-none d-md-block">
          <button class="btn btn-request">Solicitar préstamo</button>
        </div>

      </div>
    </nav>
  </div>

  <div class="overlay" *ngIf="open" (click)="open = false"></div>

  <!-- Menú Responsivo -->
  <div class="menu-responsive d-lg-none" [class.open]="open">
    <div class="my-5">
      <img class="img-fluid" src="./assets/images/logo-responsive.png" alt="logo">
    </div>
    <div class="links">
      <div class="link">
        <a class="cursor-pointer" [href]="environment.redirectHome">Inicio</a>
      </div>
      <div class="link">
        <a class="cursor-pointer" [href]="environment.redirectHome">Nosotros</a>
      </div>
      <div class="link">
        <a class="cursor-pointer" [href]="environment.redirectHome">Requisitos</a>
      </div>
      <div class="link">
        <a class="cursor-pointer" [href]="environment.redirectHome">Beneficios</a>
      </div>
      <div class="link">
        <a class="cursor-pointer" [href]="environment.redirectHome">Preguntas frecuentes</a>
      </div>
      <div class="link">
        <a class="cursor-pointer" [href]="environment.redirectHome">Blog</a>
      </div>
    </div>
    <div class="arrow" (click)="open = !open">
      <img src="assets/images/svg/arrow.svg">
    </div>
  </div>


</header>


